import React from 'react';
import FormElement from 'Components/Core/Form/FormElement';
import DialogAddBBCode from './DialogAddBBCode';

export default function DialogAddLink(props) {

    const x = props.x;
	return (

		<DialogAddBBCode 
			id={props.id} 
			x={x}   
			title={props.title} 
			classes=" dialog-add-content dialog-add-link" 
			tag="url" 
			focus={() => {x.waf.setFocus(props.id, 'url')}} 
			reset={() => {	
				x.waf.set(props.id, 'url', '');
				x.waf.set(props.id, 'url-title', '');
			}}

		>
			<FormElement x={x}   wafId={props.id} id="url-title" title="Titel" />
			<FormElement x={x}   wafId={props.id} id="url" title="URL" />
		</DialogAddBBCode>

	)
};
